module.exports = __webpack_public_path__ + "media/images/home/step_template_1st-aeeca30629f78427c0d0719c2403299e.svg";